// extracted by mini-css-extract-plugin
export default {"layout":"ChatHistory_layout__V8L7e"};